@use "variables" as *;

.container {
  flex-shrink: 0;
  align-items: center;
  justify-content: center;
  position: relative;
}

.image {
  display: block !important;
  width: 100%;
  height: auto !important;
  max-height: 100% !important;
  flex-grow: 0 !important;
  object-fit: cover !important;
}

.spineImage {
  display: block !important;
  width: auto !important;
  max-width: 100% !important;
  height: 100% !important;
  object-fit: cover !important;
}
